import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  template: `
    <nav>
      <strong>📈 Portfolio Watcher</strong>
      <a routerLink="/sign-in" routerLinkActive="active">Sign In</a>
      <a routerLink="/sign-up" routerLinkActive="active">Sign Up</a>
      <a routerLink="/profile" routerLinkActive="active">Profile</a>
      <a routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
      <a routerLink="/neon-data" routerLinkActive="active">Neon Data</a>
    </nav>
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  `,
})
export class AppComponent {}
